import { TFunction } from 'i18next'
import { object, SchemaOf, number, string } from 'yup'

export const EXCHANGE_RATE = 100
export const BUY_MIN = 10
export const BUY_MAX = 2500

export type BuySchema = {
  dstAmount: number | undefined
  promoCode: string | undefined
  // termsAgree: boolean
}

export const buySchema = (t: TFunction): SchemaOf<BuySchema> =>
  object().shape({
    promoCode: string().label('').default(''),
    dstAmount: number()
      .typeError(t('formErrors.numberTypeError'))
      .min(BUY_MIN, t('formErrors.fundsMinError', { min: BUY_MIN }))
      .max(BUY_MAX, t('formErrors.fundsMaxError', { max: BUY_MAX }))
      .nullable()
      .required()
      .label(t('main.dstAmount')),
    // termsAgree: boolean()
    //   .label(t('auth.register.acceptTermsLabel'))
    //   .required()
    //   .test(
    //     'accept_terms_valid',
    //     'You must accept conditions',
    //     accepted => accepted != null && accepted,
    //   ),
  })
